import axios from 'axios';
import type { BeamerResponse } from './types';

const API_KEY = 'b_p4nuJGLIoHxFlPdKXDtX8Q0Jua47ik0lpO+P5diZ7J4='; // This api key is read-only
const BEAMER_URL = 'https://api.getbeamer.com/v0';

// using this axios instance instead of hacking away on our axios interceptors
// because beamer api does not support some of our added headers
const uninterceptedAxios = axios.create();

/**
 * Get beamer posts
 *
 * Endpoint URL: `GET https://api.getbeamer.com/v0/posts`
 */
export const getBeamerPosts = async (): Promise<BeamerResponse> => {
  const response = await uninterceptedAxios.get(`${BEAMER_URL}/posts`, {
    headers: {
      'Beamer-Api-Key': API_KEY,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    params: {
      published: true,
    },
  });

  if (!response?.data) {
    return [];
  }

  return response.data;
};
